import React, { useEffect, useState } from 'react';
import { SelectEvent } from 'ol/interaction/Select';
import OLSelectInteraction from 'ol/interaction/Select';
import { styleFactory } from '../../utils/styleFactory';
import { actionInteractionSelectFeatures } from '../../actions';
import { useLayer } from '../../hooks/useLayer';
import { useOLMap } from '../MapContext';
export const InteractionSelect = React.memo(({ dispatch, layerId, selectedFeatureIds, multi, hitTolerance, style }) => {
    const map = useOLMap();
    const layer = useLayer(layerId);
    const [interaction, setInteraction] = useState(null);
    // dispatch
    useEffect(() => {
        if (!dispatch || !layer || !map)
            return;
        const styleInstance = style ? styleFactory(style) : null;
        const interaction = new OLSelectInteraction({
            layers: [layer],
            style: styleInstance,
            multi,
            hitTolerance,
        });
        setInteraction(interaction);
        if (process.env.NODE_ENV === 'development') {
            console.log('new OLSelectInteraction', interaction);
        }
        const onSelect = () => dispatch(actionInteractionSelectFeatures(layerId, interaction.getFeatures().getArray()));
        interaction.on('select', onSelect);
        const interactions = map.getInteractions();
        interactions.push(interaction);
        return () => {
            setInteraction(null);
            interaction.un('select', onSelect);
            interactions.remove(interaction);
        };
    }, [map, layerId, dispatch, layer, multi, hitTolerance, style]);
    useEffect(() => {
        if (!selectedFeatureIds || !interaction || !layer)
            return;
        const currentlySelectedFeaturesIds = new Set(interaction
            .getFeatures()
            .getArray()
            .map((feat) => feat.get('id')));
        const newlySelectedFeaturesIds = new Set(selectedFeatureIds);
        const needUpdate = currentlySelectedFeaturesIds.size !== newlySelectedFeaturesIds.size ||
            !Array.from(currentlySelectedFeaturesIds).every((currently) => newlySelectedFeaturesIds.has(currently));
        if (needUpdate) {
            const featuresCollection = interaction.getFeatures();
            featuresCollection.clear();
            const source = layer.getSource();
            if (!source)
                return;
            const olFeatures = source
                .getFeatures()
                .filter((feature) => newlySelectedFeaturesIds.has(feature.get('id')));
            olFeatures.forEach((feature) => featuresCollection.push(feature));
            const dispatchEventObject = new SelectEvent('select', olFeatures, [], null);
            interaction.dispatchEvent(dispatchEventObject);
        }
    }, [layer, selectedFeatureIds, interaction]);
    return null;
});
//# sourceMappingURL=InteractionSelect.js.map